import { AxiosResponse } from 'axios';

export enum AccessLevel {
    Viewer = 1,
    Owner = 2,
}

export type IDashboardLink = {
    id: string;
    uri: string;
    password?: string;
    expirationDate: string;
    isPasswordProtected?: boolean;
};

export type UserShare = {
    id: string;
    name: string;
    email: string;
    role: { id: string; name: string } | null;
    accessLevel: AccessLevel;
};

export type RequestGetSharedDashboardLink = Pick<IDashboardLink, 'id'> & { dashboardId: string };

export type ResponseGetSharedDashboardLink = AxiosResponse<IDashboardLink | null>;

export type RequestPostShareDashboardLink = Pick<IDashboardLink, 'password' | 'expirationDate'> & {
    dashboardId: string;
};

export type ResponsePostShareDashboardLink = AxiosResponse<IDashboardLink>;

export type RequestGetSharedDashboardLinks = {
    dashboardId: string;
};

export type ResponseGetSharedDashboardLinks = AxiosResponse<{ sharedLinks: IDashboardLink[] }>;

export type RequestPutSharedDashboardLink = Pick<
    IDashboardLink,
    'id' | 'password' | 'expirationDate'
> & {
    dashboardId: string;
};

export type ResponsePutSharedDashboardLink = AxiosResponse<IDashboardLink>;

export type RequestDeleteDashboardLink = {
    id: string;
    dashboardId: string;
};

export type ResponseDeleteDashboardLink = AxiosResponse<void>;

export type ResponseGetSharedDashboardToUsers = AxiosResponse<{
    users: UserShare[];
}>;

export type RequestPutShareDashboardToUsers = {
    dashboardId: string;
    users: Pick<UserShare, 'id' | 'accessLevel'>[];
};

export type RoleShare = {
    id: string;
    name: string;
};

export type ResponseGetSharedDashboardToRoles = AxiosResponse<{
    roles: RoleShare[];
}>;

export type RequestPutShareDashboardToRoles = {
    dashboardId: string;
    roleIds: string[];
};
